var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-7 -10)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H26V26H0z",
    transform: "translate(3 3)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFBD4A",
    d: "M4.157 4.106c0-.13-.1-.236-.223-.236H1.577v1.433h2.58V4.106zM4.443 6.657v.13c0 .29-.228.523-.509.523H1.577v1.128c0 .485.396.879.882.879h2.844v-2.58H4.73c-.105 0-.202-.03-.287-.08z",
    transform: "translate(3 3) translate(4.063 7.313)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBD4A",
    d: "M4.157 6.788V5.59h-2.58v1.433h2.357c.123 0 .223-.105.223-.235zM4.443 4.73v1.433c0 .158.129.287.287.287h1.433c.158 0 .287-.129.287-.287V4.73c0-.158-.129-.287-.287-.287H4.73c-.158 0-.287.129-.287.287zM4.443 4.106v.13c.085-.049.182-.08.287-.08h.573v-2.58H2.46c-.486 0-.882.395-.882.879v1.128h2.357c.281 0 .51.234.51.523z",
    transform: "translate(3 3) translate(4.063 7.313)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30343A",
    d: "M16.283 0H1.147C.516 0 0 .516 0 1.147v8.6c0 .63.516 1.146 1.147 1.146h10.606c.63 0 1.408.05 2.15-.287.501-.383 2.969-3.513 3.112-3.74.25-.396.414-.876.414-1.276V1.147C17.43.516 16.913 0 16.283 0zm-6.68 3.583V8.438c0 .644-.523 1.165-1.169 1.165H2.46c-.646 0-1.169-.521-1.169-1.165V2.455c0-.643.523-1.165 1.17-1.165h5.974c.646 0 1.17.522 1.17 1.165v1.128z",
    transform: "translate(3 3) translate(4.063 7.313)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBD4A",
    d: "M6.737 4.106v1.197h2.58V3.87H6.959c-.123 0-.222.106-.222.236zM6.45 6.788v-.131c-.085.05-.182.08-.287.08H5.59v2.58h2.844c.487 0 .883-.394.883-.879V7.31H6.959c-.281 0-.509-.234-.509-.522z",
    transform: "translate(3 3) translate(4.063 7.313)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBD4A",
    d: "M8.434 1.577H5.59v2.58h.573c.105 0 .202.03.287.08v-.131c0-.289.228-.523.509-.523h2.358V2.455c0-.484-.396-.878-.883-.878zM6.737 6.788c0 .13.1.235.222.235h2.358V5.59h-2.58v1.198z",
    transform: "translate(3 3) translate(4.063 7.313)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimIcon);
export default __webpack_public_path__ + "static/media/sim-icon.5f0f68862a2786eb28dc554352b70c76.svg";
export { ForwardRef as ReactComponent };